import type { ThemeVariant } from "../types";

export type BronteThemeWrapperClass = `theme-${string}`;

export const THEME_VARIANT_BODY_CLASSES = ["theme-main", "theme-sepia", "theme-night"] as const;

export function inferBronteThemeWrapperClass(
  themeVariant: Partial<ThemeVariant> | null | undefined,
): BronteThemeWrapperClass {
  const themeVariantName = themeVariant?.variantName?.trim().toLowerCase();
  return themeVariantName ? `theme-${themeVariantName}` : `theme-main`;
}

export function applyThemeVariantBodyClass(
  themeVariant: Partial<ThemeVariant> | null | undefined,
): void {
  if (typeof document === "undefined") return;

  document.body.classList.remove(...THEME_VARIANT_BODY_CLASSES);
  const variantName = themeVariant?.variantName?.trim().toLowerCase();
  document.body.classList.add(variantName ? `theme-${variantName}` : "theme-main");
}
